module.exports = "../../static/fonts/Lato-HairlineItalic.a567f4a.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-HairlineItalic.ttf
// module id = 921
// module chunks = 2